import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import 'rxjs';
import { Observable, Subject, throwError } from 'rxjs';
import { environment } from '../../environments/environment';
import { map } from 'rxjs/operators';
import { catchError } from 'rxjs/operators';

import { Actividad } from '../models/actividad';
@Injectable({
  providedIn: 'root'
})
export class ActividadService {

  constructor(private http: HttpClient) { }

  private actividades: Actividad[];
  private actividades$ = new Subject<Actividad[]>();

  private actividad: Actividad;
  private actividad$ = new Subject<Actividad>();

  change(val) {
    this.actividades = val;
    this.actividades$.next(this.actividades);
  }
  get$(): Observable<Actividad[]> {
    return this.actividades$.asObservable();
  }

  changeOne(val) {
    this.actividad = val;
    this.actividad$.next(this.actividad);
  }
  getOne$(): Observable<Actividad> {
    return this.actividad$.asObservable();
  }

  getAll(): Observable<Actividad[]> {
    return this.http.get(environment.apiUrl + 'actividad')
      .pipe(map((res: any) => {
        return res;
      }));
  }

  getFilter(data): Observable<Actividad[]> {

    return this.http.post(environment.apiUrl + 'actividad/getFilter', data)
      .pipe(map((res: any) => {
        return res;
      }));
  }


  get(id) {
    return this.http.get(environment.apiUrl + 'actividad/' + id)
      .pipe(map((res: any) => {
        return res;
      }));
  }
  add(data) {
    return this.http.post(environment.apiUrl + 'actividad', data)
      .pipe(
        map((res: any) => { return res; }),
        catchError(e => throwError(e))
      );
  }
  edit(data) {
    const apiUrl = environment.apiUrl + 'actividad';
    const url = `${apiUrl}/${data["id"]}`;


    return this.http.put(url, data)
      .pipe(
        map((res: any) => { return res; }),
        catchError(e => throwError(e))
      );
  }

  delete(id) {

    return this.http.delete(environment.apiUrl + 'actividad/' + id)
      .pipe(
        map((res: any) => { return res; }),
        catchError(e => throwError(e))
      );
  }


  getTipo() {
    return this.http.get(environment.apiUrl + 'actividad/getTipo')
      .pipe(map((res: any) => {
        return res;
      }));
  }
  getSeccion() {
    return this.http.get(environment.apiUrl + 'actividad/getSeccion')
      .pipe(map((res: any) => {
        return res;
      }));
  }

  changeImagePrincipal(formData: FormData, id): Observable<object> {
    return this.http.post(environment.apiUrl + 'actividad/changeImgPrincipal/' + id, formData)
      .pipe(
        map((res: any) => { return res.data; }),
        catchError(e => throwError(e))
      );
  }

  changeImageExtra(formData: FormData, id): Observable<object> {
    return this.http.post(environment.apiUrl + 'actividad/changeImgExtra/' + id, formData)
      .pipe(
        map((res: any) => { return res.data; }),
        catchError(e => throwError(e))
      );
  }

  deleteImg(id) {
    return this.http.delete(environment.apiUrl + 'actividad/deleteImg/' + id)
      .pipe(
        map((res: any) => { return res; }),
        catchError(e => throwError(e))
      );
  }
}
